<ng-template #body>
  <span class="kpi-tile__body">
    <span data-testid="kpi-label" class="kpi-tile__label" [attr.title]="kpi?.label">{{ kpi?.label }}</span>
    @if (kpi?.notApplicable) {
      <span data-testid="kpi-na" class="kpi-na"><i class="fa-regular fa-address-card"></i> No Client Manager record</span>
    } @else {
      <span class="kpi-tile__figure">
        <span data-testid="kpi-value" class="kpi-tile__value">{{ valueText }}</span>
        @if (unitText) {
          <span data-testid="kpi-unit" class="kpi-tile__unit">{{ unitText }}</span>
        }
      </span>
      @if (collectingText) {
        <span data-testid="kpi-history" class="kpi-tile__delta kpi-tile__delta--collecting">
          <i class="fa-regular fa-hourglass-half" aria-hidden="true"></i>{{ collectingText }}
        </span>
      } @else {
        <span data-testid="kpi-delta" class="kpi-tile__delta" [attr.data-tone]="tone">{{ deltaText }}</span>
      }
    }
  </span>
  @if (!kpi?.notApplicable && kpi?.series?.length) {
    <span class="kpi-tile__spark">
      <app-admin-dashboard-sparkline [series]="kpi.series" [tone]="tone" [format]="formatPoint"
                                     [name]="sparkName"></app-admin-dashboard-sparkline>
    </span>
  }
</ng-template>
@if (selectable && section) {
  <button type="button" data-testid="kpi-tile" class="kpi-tile kpi-tile--action" [attr.data-key]="kpi?.key"
          (click)="sectionRequested.emit(section)">
    <ng-container [ngTemplateOutlet]="body"></ng-container>
  </button>
} @else {
  <div data-testid="kpi-tile" class="kpi-tile" [attr.data-key]="kpi?.key">
    <ng-container [ngTemplateOutlet]="body"></ng-container>
  </div>
}
